import { useEffect, useState } from "react";
import { useAuth } from "../app/modules/auth";
import { decrypt } from "../app/modules/auth/core/_requests";

export const useDecryptedRole = () => {
	const { currentUser } = useAuth();
	const [roleId, setRoleId] = useState<number | null>(null);

	useEffect(() => {
		const decryptRole = async () => {
			if (currentUser?.role_id) {
				if (typeof currentUser.role_id === "string") {
					try {
						const decrypted = await decrypt(currentUser.role_id);
						setRoleId(Number(decrypted));
					} catch (err) {
						console.error("Failed to decrypt role_id:", err);
					}
				} else {
					setRoleId(Number(currentUser.role_id));
				}
			}
		};
		decryptRole();
	}, [currentUser?.role_id]);

	return roleId;
};
